<app-text class="has-text-medium-grey">
  <ng-content></ng-content>
</app-text>
